<template>
    <section>

        <b-table :data="work_experiences" paginated per-page=10 :pagination-simple=false pagination-position="bottom"
            aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
            aria-current-label="Página actual" detailed custom-detail-row >

            <b-table-column label="Código Asignatura" field="codigo" width="100" sortable searchable>
                <template #searchable="props">
                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Código..." icon="search" />
                </template>
                <template v-slot="props">
                    {{ props.row.codigo }}
                </template>
            </b-table-column>

            <b-table-column label="Asignatura" field="asignatura" sortable searchable>
                <template #searchable="props">
                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Asignatura..."
                        icon="search" />
                </template>
                <template v-slot="props">
                    {{ props.row.asignatura }}
                </template>
            </b-table-column>

            <b-table-column label="Carrera" field="nombre_carrera" sortable searchable>
                <template #searchable="props">
                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Carrera..."
                        icon="search" />
                </template>
                <template v-slot="props">
                    {{ props.row.nombre_carrera }}
                </template>
            </b-table-column>

            <b-table-column label="Tipo Programa" field="tipo_programa" sortable searchable>
                <template #searchable="props">
                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Tipo..." icon="search" />
                </template>
                <template v-slot="props">
                    {{ props.row.tipo_carrera }}
                </template>
            </b-table-column>

            <b-table-column label="Semestre/Año Dictado" field="agno" sortable searchable>
                <template #searchable="props">
                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Año..." icon="search" />
                </template>
                <template v-slot="props">
                    {{ props.row.semestre + '/' + props.row.agno }}
                </template>
            </b-table-column>

            <template #detail="props">
                <tr v-for="item in props.row.common_subjects" :key="item.codigo" >
                    <td></td>
                    <td>{{ item.codigo }}</td>
                    <td>{{ item.asignatura }}</td>
                    <td>{{ item.nombre_carrera }}</td>
                    <td>{{ item.tipo_carrera }}</td>
                    <td>{{ item.semestre + '/' + item.agno }}</td>
                </tr>
            </template>

            <template slot="empty">
                <div class="columns is-centered">
                    <div class="column is-6 is-centered has-text-centered">
                        <b-message has-icon type="is-warning">
                            <h1> No se encontraron resultados.</h1>
                        </b-message>
                    </div>
                </div>
            </template>

        </b-table>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />

    </section>
</template>

<script>
import axios from 'axios'
export default {
    props: [
        'personId', 'photoUrl', 'cargoPrincipal', 'canCreateDocument'
    ],
    data() {
        return {
            isLoading: false,
            work_experiences: [],
        }
    },
    async created() {
        await this.getWorkExperiences()
    },
    methods: {

        async getWorkExperiences() {
            this.isLoading = true
            await axios
                .get('/people/my_usach_experiences.json', {
                    params: {
                        id: this.personId
                    }
                })
                .then(response => {
                    this.work_experiences = response.data
                    this.work_experiences.forEach((work_experience) => {
                        work_experience.agno = work_experience.agno.toString()
                        work_experience.semestre = work_experience.semestre.toString()
                        work_experience.codigo = work_experience.codigo.toString()
                    })
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    }
}
</script>